import React from 'react';
import { RendererProps } from '@tunz/data-tables';
import RouterLinkFormatter from './RouterLinkFormatter';
import { LinkProps } from './types';

export const SearchTrxLink: React.FC<LinkProps> = ({ id }) => {
	const LinkFormatter = RouterLinkFormatter((value: string) => `/transfer/search?trxId=${value}`);
	return <LinkFormatter value={id} record={{ value: id }} />;
};

export const SearchTrxLinkRenderer = ({
	value,
	record,
}: RendererProps<string>): React.JSX.Element => {
	const LinkFormatter = RouterLinkFormatter(() => `/transfer/search?trxId=${value}`);
	return (
		<span className="mx-2">
			<LinkFormatter value={value} record={record} />
		</span>
	);
};
